import { constants } from "../constants/redux-constants";

const initialState = {
  totalPatients: false,
  recentActivity: false,
  referral: false,
  patientEngagement: false,
  patientsWidget: false,
  clinicalNotesWidget: false,
  homeDashboardLoading: false
};

const dashboardWidgetsLoadingReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.INSIGHTS.SET_WIDGET_LOADING:
      return {
        ...state,
        [action.payload.widgetKey]: action.payload.isLoading,
      };
    default:
      return state;
  }
};

export default dashboardWidgetsLoadingReducer;
